module.exports = __webpack_public_path__ + "static/media/14UNEP13.5850782b.jpg";